<!-- ===== HERO SECTION (same style as user home) ===== -->
<section class="company-hero-container">
  <!-- Same background image as user home -->
  <img class="hero-bg-img" src="assets/img/hero-img.webp" alt="hero background" />

  <!-- Content overlay -->
  <div class="hero-overlay-content">
    <div class="hero-dash"></div>
    <h1 class="company-hero-title">
      {{ "companyHome.heroTitle" | translate }}
    </h1>
    <p class="company-hero-subtitle">
      {{ "companyHome.heroSubtitle" | translate }}
    </p>

    <button class="btn-start-hiring" (click)="goToDashboard()">
      <span>{{ "companyHome.startHiring" | translate }}</span>
      <span class="btn-arrow-circle">
        <i class="bi bi-arrow-up-right"></i>
      </span>
    </button>

    <div class="trusted-badge">
      <div class="avatar-group">
        <div class="av av1"><i class="bi bi-person-fill"></i></div>
        <div class="av av2"><i class="bi bi-person-fill"></i></div>
        <div class="av av3"><i class="bi bi-person-fill"></i></div>
        <div class="av av4"><i class="bi bi-person-fill"></i></div>
      </div>
      <span class="trusted-text">
        {{ "landing.trusted" | translate:{ count: 1200 } }}
      </span>
    </div>
  </div>

  <!-- Dashboard Preview Card (overlapping bottom of hero) -->
  <div class="dashboard-preview-wrapper">
    <img src="assets/img/Frame 2095588616.png" alt="Dashboard Preview" class="dashboard-preview-img" />
  </div>
</section>

<!-- ===== TRUSTED BRANDS & STATS ===== -->
<section class="trusted-stats-section">
  <div class="section-inner trusted-stats-inner">
    
    <!-- Left: Brands -->
    <div class="brands-left">
      <p class="brands-label">{{ "companyHome.trustedByGrowing" | translate }}</p>
      <div class="brands-list">
        <div class="brand-item" *ngFor="let brand of brands">
          <img [src]="brand.img" [alt]="brand.name" class="brand-logo" />
          <span>{{ brand.name }}</span>
        </div>
      </div>
    </div>

    <!-- Right: Stats -->
    <div class="stats-right">
      <div class="stat-card" *ngFor="let s of stats">
        <div class="stat-value">{{ s.value }}</div>
        <div class="stat-label">{{ s.label | translate }}</div>
      </div>
    </div>

  </div>
</section>

<!-- ===== WHY TRADITIONAL HIRING ===== -->
<section class="why-section">
  <div class="section-inner why-inner">
    <h2 class="why-title">{{ "companyHome.whyTitle" | translate }}</h2>
    <p class="why-subtitle">
      {{ "companyHome.whySubtitle" | translate }}
    </p>
    <div class="reasons-grid">
      <div class="reason-card" *ngFor="let r of reasons">
        <div class="reason-number">{{ r.number }}</div>
        <h3 class="reason-title">{{ r.title | translate }}</h3>
        <p class="reason-desc">{{ r.desc | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== BUILT FOR RECRUITERS ===== -->
<section class="built-section">
  <div class="section-inner built-inner">
    <h2 class="built-title">{{ "companyHome.builtTitle" | translate }}</h2>
    <p class="built-subtitle">
      {{ "companyHome.builtSubtitle" | translate }}
    </p>
    <div class="built-grid">
      <div class="built-card" *ngFor="let feat of builtFeatures">
        <div class="built-icon-wrap" [ngStyle]="{'background-color': feat.iconBg, 'color': feat.iconColor}">
          <i class="bi {{feat.icon}}"></i>
        </div>
        <h3 class="built-card-title">{{ feat.title | translate }}</h3>
        <p class="built-card-desc">{{ feat.desc | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== HIRE BETTER SECTION ===== -->
<app-hire-better-section></app-hire-better-section>

<!-- ===== SMART JOB POSTING & TALENT PROFILES ===== -->
<section class="smart-profiles-section">
  <div class="section-inner smart-profiles-inner">
    
    <!-- Left Column: Smart Job Posting -->
    <div class="smart-job-posting">
      <img src="assets/img/Job Posting Feature.png" alt="Smart Job Posting" class="smart-job-img" />
      <h3 class="smart-job-title">{{ "companyHome.smartJobTitle" | translate }}</h3>
      <p class="smart-job-desc">
        {{ "companyHome.smartJobDesc" | translate }}
      </p>
      <ul class="smart-job-list">
        <li><i class="bi bi-check-circle-fill"></i> {{ "companyHome.smartJob1" | translate }}</li>
        <li><i class="bi bi-check-circle-fill"></i> {{ "companyHome.smartJob2" | translate }}</li>
        <li><i class="bi bi-check-circle-fill"></i> {{ "companyHome.smartJob3" | translate }}</li>
        <li><i class="bi bi-check-circle-fill"></i> {{ "companyHome.smartJob4" | translate }}</li>
      </ul>
      <a routerLink="/job-post" class="smart-job-learn-more">{{ "companyHome.learnMore" | translate }} <i class="bi bi-arrow-right"></i></a>
    </div>

    <!-- Right Column: Meet UpCareer Talent Profiles -->
    <div class="talent-profiles">
      <h3 class="talent-profiles-title">{{ "companyHome.talentTitle" | translate }}</h3>
      <p class="talent-profiles-desc">
        {{ "companyHome.talentDesc" | translate }}
      </p>
      <ul class="talent-profiles-list">
        <li><span></span> {{ "companyHome.talent1" | translate }}</li>
        <li><span></span> {{ "companyHome.talent2" | translate }}</li>
        <li><span></span> {{ "companyHome.talent3" | translate }}</li>
      </ul>

      <!-- Mock UI Cards -->
      <div class="talent-cards-wrapper">
        <!-- Card 1: Alex Rivera -->
        <div class="talent-card-1">
          <div class="tc-header">
            <div class="tc-info">
              <h4>Alex Rivera</h4>
              <p>Senior Product Designer</p>
              <span class="tc-location"><i class="bi bi-geo-alt"></i> San Francisco, CA</span>
            </div>
            <div class="tc-actions">
              <button class="btn-edit-profile">{{ "companyHome.editProfile" | translate }}</button>
              <button class="btn-upload-cv"><i class="bi bi-upload"></i> {{ "Upload CV" | translate }}</button>
            </div>
          </div>
          <div class="tc-footer">
            <span class="badge-open">{{ "companyHome.openToWork" | translate }}</span>
            <span class="badge-blue-collar">Blue collar</span>
          </div>
        </div>

        <!-- Card 2: Education -->
        <div class="talent-card-2">
          <div class="edu-timeline">
            <div class="edu-item">
              <div class="edu-icon"><i class="bi bi-mortarboard-fill"></i></div>
              <div class="edu-details">
                <h5>University of California, Berkeley</h5>
                <p>Master of Science in Human-Computer Interaction ( 2016 – 2018 )</p>
              </div>
            </div>
            <div class="edu-line"></div>
            <div class="edu-item">
              <div class="edu-icon"><i class="bi bi-mortarboard-fill"></i></div>
              <div class="edu-details">
                <h5>Stanford University</h5>
                <p>Bachelor of Arts in Design 2012 – 2016</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- ===== COMING SOON SECTION ===== -->
<app-coming-soon-section></app-coming-soon-section>

<!-- ===== WHY CHOOSE SECTION ===== -->
<section class="why-choose-section">
  <div class="section-inner why-choose-inner">
    <div class="why-choose-header">
      <h2>{{ "companyHome.whyChooseTitle" | translate }}</h2>
      <p>{{ "companyHome.whyChooseSubtitle" | translate }}</p>
    </div>
    
    <div class="why-choose-grid">
      <!-- Card 1 -->
      <div class="wc-card">
        <h3>{{ "companyHome.wc1Title" | translate }}</h3>
        <p>{{ "companyHome.wc1Desc" | translate }}</p>
      </div>
      <!-- Card 2 -->
      <div class="wc-card">
        <h3>{{ "companyHome.wc2Title" | translate }}</h3>
        <p>{{ "companyHome.wc2Desc" | translate }}</p>
      </div>
      <!-- Card 3 -->
      <div class="wc-card">
        <h3>{{ "companyHome.wc3Title" | translate }}</h3>
        <p>{{ "companyHome.wc3Desc" | translate }}</p>
      </div>
      <!-- Card 4 -->
      <div class="wc-card">
        <h3>{{ "companyHome.wc4Title" | translate }}</h3>
        <p>{{ "companyHome.wc4Desc" | translate }}</p>
      </div>
      <!-- Card 5 -->
      <div class="wc-card">
        <h3>{{ "companyHome.wc5Title" | translate }}</h3>
        <p>{{ "companyHome.wc5Desc" | translate }}</p>
      </div>
      <!-- Card 6 -->
      <div class="wc-card highlight-card">
        <h3>68%</h3>
        <p>{{ "companyHome.wc6Desc" | translate }}</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== THREE STEPS SECTION ===== -->
<section class="three-steps-section">
  <div class="section-inner three-steps-inner">
    <h2>{{ "companyHome.threeStepsTitle" | translate }}</h2>
    
    <div class="three-steps-grid">
      <!-- Step 1 -->
      <div class="step-card">
        <div class="step-icon-wrap" style="background: #eff6ff; color: #3b82f6;">
          <i class="bi bi-briefcase-fill"></i>
          <span class="step-badge">1</span>
        </div>
        <h3>{{ "companyHome.step1Title" | translate }}</h3>
        <p>{{ "companyHome.step1Desc" | translate }}</p>
      </div>

      <!-- Step 2 -->
      <div class="step-card">
        <div class="step-icon-wrap" style="background: #eef2ff; color: #6366f1;">
          <i class="bi bi-camera-video-fill"></i>
          <span class="step-badge">2</span>
        </div>
        <h3>{{ "companyHome.step2Title" | translate }}</h3>
        <p>{{ "companyHome.step2Desc" | translate }}</p>
      </div>

      <!-- Step 3 -->
      <div class="step-card">
        <div class="step-icon-wrap" style="background: #faf5ff; color: #a855f7;">
          <i class="bi bi-people-fill"></i>
          <span class="step-badge">3</span>
        </div>
        <h3>{{ "companyHome.step3Title" | translate }}</h3>
        <p>{{ "companyHome.step3Desc" | translate }}</p>
      </div>
    </div>
<!-- ===== START ACHIEVING SECTION ===== -->
<app-start-achieving-section></app-start-achieving-section>
